import { AnswersActionTypes } from "./answerTypes";
const initialState = {
    list: []
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case AnswersActionTypes.FETCH_ANSWERS_SUCCESS:
            return Object.assign(Object.assign({}, state), { list: action.payload });
        default:
            return state;
    }
};
export { reducer as answerReducer };
